import nexus from '@db2b/nexus-js'
import { Message } from 'element-ui'

export default {
  beforeEnterRoute (store, to, from, next) {
    // If there is missing data into the storage, logout the user
    try {
      if (store.getters['users/current']) {}
      if (store.getters['user_preferences/current'].payload) {}
    } catch (e) {
      Message({
        message: 'Une erreur est survenue lors du chargement de votre compte. Merci de vous reconnecter.'
      })
      next('/session/logout')
    }

    // Check if there is a nexus token and is the current user is loaded
    if (!nexus.hasToken() || !store.getters['users/isCurrentUserLoaded']) {
      Message({
        message: 'Une erreur est survenue lors de votre authentification. Merci de vous reconnecter.'
      })
      next('/session/login')
    } else {
      next()
    }
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/services/app.js